import { render, staticRenderFns } from "./FeatureLandingPage.vue?vue&type=template&id=71d23ffe"
import script from "./FeatureLandingPage.vue?vue&type=script&lang=js"
export * from "./FeatureLandingPage.vue?vue&type=script&lang=js"
import style0 from "./FeatureLandingPage.vue?vue&type=style&index=0&id=71d23ffe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports